module.exports = __webpack_public_path__ + "img/2.48ae4c5b.jpg";